import React, { useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import ThemeableAgGrid from "../../../common/components/agGrid/ThemeableAgGrid";
import { useTranslation } from "react-i18next";
import { formatDate, formatDateTime } from "../../../common/services/utilities";

const TermTable = ({ terms, onSort, onRowClick }) => {
  const { t } = useTranslation(["markets"]);

  // Memoize column definitions
  const columnDefs = useMemo(
    () => [
      {
        field: "name",
        headerName: t("Name"),
        sortable: true,
        filter: true,
        flex: 1.5,
      },
      {
        field: "termScheduleName",
        headerName: t("TermSchedule"),
        sortable: true,
        filter: true,
        flex: 2,
      },
      {
        field: "startDate",
        headerName: t("StartDate"),
        sortable: true,
        filter: true,
        flex: 1.5,
        cellRenderer: (params) => {
          const term = params.data;
          return term.startDate.slice(-8) === "00:00:00" &&
            term.endDate.slice(-8) === "00:00:00"
            ? formatDate(term.startDate)
            : formatDateTime(term.startDate);
        },
      },
      {
        field: "endDate",
        headerName: t("EndDate"),
        sortable: true,
        filter: true,
        flex: 1.5,
        cellRenderer: (params) => {
          const term = params.data;
          return term.startDate.slice(-8) === "00:00:00" &&
            term.endDate.slice(-8) === "00:00:00"
            ? formatDate(term.endDate)
            : formatDateTime(term.endDate);
        },
      },
      {
        field: "spotStartDate",
        headerName: t("SpotStartDate"),
        sortable: true,
        filter: true,
        flex: 1.2,
        valueFormatter: (params) =>
          params.value ? formatDate(params.value) : "",
      },
      {
        field: "spotEndDate",
        headerName: t("SpotEndDate"),
        sortable: true,
        filter: true,
        flex: 1.2,
        valueFormatter: (params) =>
          params.value ? formatDate(params.value) : "",
      },
      {
        field: "active",
        headerName: t("Active"),
        sortable: true,
        filter: true,
        flex: 1,
        // Apply centered class for better alignment
        headerClass: "ag-center-aligned-header",
        cellRenderer: (params) => {
          const isActive = params.data?.active;
          return (
            <div className="centered" style={{ width: "100%", height: "100%" }}>
              <FontAwesomeIcon
                icon={isActive ? faCheck : faTimes}
                className={isActive ? "text-success" : "text-danger"}
                style={{ fontSize: "16px" }}
              />
            </div>
          );
        },
      },
    ],
    [t]
  );

  // Memoize default column properties
  const defaultColDef = useMemo(
    () => ({
      resizable: true,
      minWidth: 100,
    }),
    []
  );

  // Memoize grid options
  const gridOptions = useMemo(
    () => ({
      pagination: true,
      paginationAutoPageSize: false,
      paginationPageSize: 20,
      paginationPageSizeSelector: [5, 10, 20, 50, 100],
      suppressPaginationPanel: false,
    }),
    []
  );

  return (
    <div style={{ height: "600px", width: "100%" }}>
      <ThemeableAgGrid
        className="table-bold clickable"
        columnDefs={columnDefs}
        defaultColDef={defaultColDef}
        gridOptions={gridOptions}
        rowData={terms}
        onSortChanged={onSort}
        onRowClicked={(params) => onRowClick(params.data)}
        getRowId={(params) => params.data.termId.toString()}
        animateRows={true}
      />
    </div>
  );
};

export default TermTable;




